import { AsmAuthEffects } from './asm-auth.effect';
import { CustomerEffects } from './customer.effect';

export const effects: any[] = [AsmAuthEffects, CustomerEffects];
